import { type FC } from "react";

/**
 * OthersApp - landing page for miscellaneous workspace
 *
 * @returns OthersApp component
 *
 */
export const OthersApp: FC = () => {
  return <div className="p-4">Other Workspaces</div>;
};
